import { useTranslation } from "react-i18next";
import { Text, tokens } from "shared/components/Spor";
import styled from "styled-components";

const Wrapper = styled.div`
  grid-column-start: 1;
  grid-column-end: -1;
  grid-row-start: content;

  display: flex;
  justify-content: flex-start;
  align-items: center;

  padding: ${tokens.default.size.spacing[2]};
  gap: ${tokens.default.size.spacing[0.5]};

  border-radius: ${tokens.default.size.spacing[1]};
`;

type GridEmptyElementProps = {
  emptyText?: string;
};

export const GridEmptyElement = ({ emptyText }: GridEmptyElementProps) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Text variant="sm" color="text.disabled">
        {emptyText || t("Ingen treff")}
      </Text>
    </Wrapper>
  );
};
